<template>
    <div class="error">
        <el-image
            v-if="this.$route.query.id==404"
            fit="cover"
            style="width:1000px;height:600px"
            :src="src.src_err_404"
        >
            <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                <div class="el_image">
                    <el-image  fit="cover" :src="src.src_err"  style="width:200px;height:200px;"></el-image>
                </div>
            </div>
        </el-image>
        <el-image
            v-if="this.$route.query.id==500"
            fit="cover"
            style="width:1000px;height:600px"
            :src="src.src_err_500"
        >
            <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                <div class="el_image">
                    <el-image  fit="cover" :src="src.src_err"  style="width:200px;height:200px;"></el-image>
                </div>
            </div>
        </el-image>
    </div>
</template>
<script>
import src_err from '@/assets/img/err.png'
import src_err_404 from '@/assets/img/err_404.png'
import src_err_500 from '@/assets/img/err_500.png'

export default {
    name:'error',
    data(){
        return {
            src:{
                src_err,
                src_err_404,
                src_err_500
            },
        }
    }
}
</script>
<style lang="scss" scoped>
.error{
    display:flex;
    align-items:center;
    justify-content:center;
    /*box-sizing:border-box;*/
    /*padding-top:110px;*/
    min-height:100%;
}
</style>
